const MIN_PORT = 1;
const MAX_PORT = 65535;
const PORTS_REGEX = /^[1-9]\d*( *- *)?([1-9]\d*)*$/;

export const INVALID_PORT_ERR = 'Invalid port(s).';
export const MIN_PORT_ERR = 'Port must be > 0.';
export const MAX_PORT_ERR = 'Port cannot exceed 65535.';
export const ORDER_ERR = 'End must be > start.';

/**
 * Validates user input is a valid port number or range of valid port numbers.
 *
 * @param ports a port or range of ports to validate
 * @returns true if valid and a string error message if not
 */
export function validatePorts(ports: string): string | true {
  // Empty values are allowed
  if (ports.trim() === '') {
    return true;
  }

  if (ports.trim() === '0') {
    return MIN_PORT_ERR;
  }

  if (ports.trim().toLowerCase() === 'any') return true;

  if (!PORTS_REGEX.test(ports.trim())) {
    return INVALID_PORT_ERR;
  }

  const [start, end = ''] = ports.split('-');

  try {
    const startPort = Number(start);

    if (startPort < MIN_PORT) {
      return MIN_PORT_ERR;
    }

    if (startPort > MAX_PORT) {
      return MAX_PORT_ERR;
    }

    if (end) {
      const endPort = Number(end);

      if (endPort < MIN_PORT) {
        return MIN_PORT_ERR;
      }

      if (endPort > MAX_PORT) {
        return MAX_PORT_ERR;
      }

      if (endPort <= startPort) {
        return ORDER_ERR;
      }
    }

    // Had a dash, but no end
    else if (ports.includes('-')) {
      return INVALID_PORT_ERR;
    }
  } catch {
    return INVALID_PORT_ERR;
  }

  return true;
}
